// packages
import { z } from 'zod'
import { User } from './user'
import { privateRouteSchema } from './route'

// enums
export enum anamnese_status {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export enum formatted_anamnese_status {
  ACTIVE = 'Ativo',
  DELETED = 'Deletado'
}

export enum anamnese_profile_types {
  PREGNANT = 'PREGNANT',
  LACTATING = 'LACTATING',
  CHILDREN = 'CHILDREN',
  TEMPTING = 'TEMPTING',
  WOMAN = 'WOMAN'
}

export enum formatted_anamnese_profile_types {
  PREGNANT = 'Grávidas',
  LACTATING = 'Lactantes',
  CHILDREN = 'Crianças',
  TEMPTING = 'Homens',
  WOMAN = 'Mulheres'
}

// types
export type AnamneseProps = {
  id?: number
  ref?: string
  userId?: number
  index?: number
  title?: string
  paths?: string[]
  status?: anamnese_status
  profileType?: anamnese_profile_types
  createdAt?: Date
  updatedAt?: Date | null
  file?: {
    file?: File
    name?: string
    extension?: string
    base64?: string
    url?: string
  }

  // relationships
  user?: User
}

export type CreateAnamneseSchema = z.infer<typeof createAnamneseSchema>
export type UpdateAnamneseSchema = z.infer<typeof updateAnamneseSchema>
export type GetAnamnesesSchema = z.infer<typeof getAnamnesesSchema>
export type GetAnamneseByRefSchema = z.infer<typeof getAnamneseByRefSchema>
export type DeleteAnamneseSchema = z.infer<typeof deleteAnamneseSchema>

// schemas
export const createAnamneseSchema = privateRouteSchema.extend({
  title: z.string({ message: 'Informe o título.' }).min(1, 'Título inválido.').max(100, 'Limite de caracteres: 100.'),
  profileType: z.nativeEnum(anamnese_profile_types, { message: 'Informe o tipo de perfil.' }),
  paths: z.array(z.string()).optional()
})
export const updateAnamneseSchema = createAnamneseSchema.extend({
  ref: z.string({ message: 'Informe o ref.' }).min(1, 'Ref inválida.').max(100, 'Limite de caracteres: 100.')
})
export const getAnamnesesSchema = privateRouteSchema
export const deleteAnamneseSchema = z.object({
  ref: z.string({ message: 'Informe o ref.' }).min(1, 'Ref inválida.').max(100, 'Limite de caracteres: 100.')
})
export const getAnamneseByRefSchema = z.object({
  ref: z.string({ message: 'Informe o ref.' }).min(1, 'Ref inválida.').max(100, 'Limite de caracteres: 100.')
})

export class Anamnese {
  private props: AnamneseProps

  get id() {
    return this.props.id
  }

  get ref() {
    return this.props.ref
  }

  get userId() {
    return this.props.userId
  }

  get index() {
    return this.props.index
  }

  get title() {
    return this.props.title
  }

  get paths() {
    return this.props.paths
  }

  get status() {
    return this.props.status
  }

  get profileType() {
    return this.props.profileType
  }

  get createdAt() {
    return this.props.createdAt
  }

  get updatedAt() {
    return this.props.updatedAt
  }

  get user() {
    return this.props.user
  }

  constructor(props: AnamneseProps) {
    this.props = props
  }
}
